const i = (o, n, s) => {
  const t = /* @__PURE__ */ new Date();
  t.setTime(t.getTime() + s * 24 * 60 * 60 * 1e3);
  const e = "expires=" + t.toUTCString();
  document.cookie = o + "=" + n + ";" + e + ";path=/";
}, c = (o) => {
  const n = o + "=", s = document.cookie.split(";");
  for (let t = 0; t < s.length; t++) {
    let e = s[t];
    for (; e.charAt(0) === " "; )
      e = e.substring(1);
    if (e.indexOf(n) === 0)
      return e.substring(n.length, e.length);
  }
  return "";
}, r = (o) => {
  i(o, "", -1);
}, l = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getCookie: c,
  removeCookie: r,
  setCookie: i
}, Symbol.toStringTag, { value: "Module" }));
export {
  l as c,
  c as g,
  r,
  i as s
};
